import moment from "moment";
import React, { useEffect } from "react";
import DatePicker from "react-datepicker";
import { Controller } from "react-hook-form";
import { useProduccionForm } from "../hooks/useProduccionForm";
import LoadMask from "Utils/LoadMask/LoadMask";
import { OrdenesProduccion } from "./OrdenesProduccion/OrdenesProduccion";
import { ResumenTotal } from "./ResumenTotal";
import {
    getWeekRange,
    getWeeksInYear,
    LOCALE_CALENDARIO_DOMINGO,
} from "../../../../helpers/dateRange";

export const ProduccionForm = ({ regresar }) => {
    const {
        formControl,
        formRegister,
        formErrors,
        formWatch,
        formGetValues,
        formSetValue,

        ordenesProduccion,
        setOrdenesProduccion,
        FormSubmit,
        cargando,
    } = useProduccionForm(regresar);

    // --------------------------------------------------------------
    // Validaciones y efectos relacionados con el año y la semana
    // --------------------------------------------------------------
    const currentYear = new Date().getFullYear();

    const semana = formWatch("semana");
    const anio = formWatch("anio");

    // Si el año cambia, validar que la semana no sea mayor a las semanas máximas del año
    useEffect(() => {
        if (!anio) return;

        const maxWeeks = getWeeksInYear(anio);
        const semanaActual = formGetValues("semana");

        if (semanaActual > maxWeeks) {
            formSetValue("semana", maxWeeks);
        }
    }, [anio]);

    // Si la semana o el año cambian, actualizar las fechas
    useEffect(() => {
        if (!semana || !anio) return;

        const { start, end } = getWeekRange(semana, anio);

        formSetValue("fecha_inicial", moment(start));
        formSetValue("fecha_final", moment(end));
    }, [semana, anio]);

    return (
        <LoadMask loading={cargando} blur>
            <div className="formulario-fields-row">
                <div className="formulario-field">
                    <label className="text-nowrap">No. Producción</label>
                    <input
                        type="text"
                        className={`form-control ${formErrors.numero ? "is-invalid" : ""}`}
                        {...formRegister("numero", {
                            required: "Este campo es obligatorio",
                        })}
                        disabled
                    />
                    {formErrors.numero && (
                        <small className="text-danger">
                            {formErrors.numero.message}
                        </small>
                    )}
                </div>
                <div className="formulario-field" style={{ minWidth: "100px" }}>
                    <label className="text-nowrap">Año</label>
                    <Controller
                        name="anio"
                        control={formControl}
                        rules={{
                            required: "Este campo es obligatorio",
                            min: {
                                value: currentYear - 5,
                                message: "Mínimo " + (currentYear - 5),
                            },
                            max: {
                                value: currentYear + 5,
                                message: "Máximo " + (currentYear + 5),
                            },
                        }}
                        render={({ field }) => (
                            <input
                                type="number"
                                min={currentYear - 5}
                                max={currentYear + 5}
                                className={`form-control ${formErrors.anio ? "is-invalid" : ""}`}
                                {...field}
                            />
                        )}
                    />
                    {formErrors.anio && (
                        <small className="text-danger">
                            {formErrors.anio.message}
                        </small>
                    )}
                </div>

                <div className="formulario-field" style={{ minWidth: "100px" }}>
                    <label className="text-nowrap">Semana</label>
                    <Controller
                        name="semana"
                        control={formControl}
                        rules={{
                            required: "Este campo es obligatorio",
                            min: { value: 1, message: "Mínimo 1" },
                            max: {
                                value: getWeeksInYear(anio),
                                message: "Semana inválida para ese año",
                            },
                        }}
                        render={({ field }) => (
                            <input
                                type="number"
                                min={1}
                                max={getWeeksInYear(anio)}
                                className={`form-control ${formErrors.semana ? "is-invalid" : ""}`}
                                {...field}
                            />
                        )}
                    />
                    {formErrors.semana && (
                        <small className="text-danger">
                            {formErrors.semana.message}
                        </small>
                    )}
                </div>
                <div className="formulario-field" style={{ minWidth: "120px" }}>
                    <label className="text-nowrap">Fecha inicial</label>
                    <Controller
                        name="fecha_inicial"
                        control={formControl}
                        rules={{
                            required: "Este campo es obligatorio",
                        }}
                        render={({ field }) => (
                            <DatePicker
                                selected={field.value}
                                onChange={(date) => {
                                    field.onChange(date);
                                }}
                                showPopperArrow={false}
                                locale={LOCALE_CALENDARIO_DOMINGO}
                                dateFormat="DD/MM/YYYY"
                                placeholderText="Fecha de inicio"
                                maxDate={formControl._formValues.fecha_final}
                            />
                        )}
                    />
                    {formErrors.fecha_inicial && (
                        <small className="text-danger">
                            {formErrors.fecha_inicial.message}
                        </small>
                    )}
                </div>
                <div className="formulario-field" style={{ minWidth: "120px" }}>
                    <label className="text-nowrap">Fecha final</label>
                    <Controller
                        name="fecha_final"
                        control={formControl}
                        rules={{
                            required: "Este campo es obligatorio",
                        }}
                        render={({ field }) => (
                            <DatePicker
                                selected={field.value}
                                onChange={(date) => {
                                    field.onChange(date);
                                }}
                                showPopperArrow={false}
                                locale={LOCALE_CALENDARIO_DOMINGO}
                                dateFormat="DD/MM/YYYY"
                                placeholderText="Fecha final"
                                minDate={formControl._formValues.fecha_inicial}
                            />
                        )}
                    />
                    {formErrors.fecha_final && (
                        <small className="text-danger">
                            {formErrors.fecha_final.message}
                        </small>
                    )}
                </div>
            </div>
            <OrdenesProduccion
                ordenesProduccion={ordenesProduccion}
                setOrdenesProduccion={setOrdenesProduccion}
            />
            <ResumenTotal ordenesProduccion={ordenesProduccion} />
            <div className="d-flex justify-content-center mt-3 gap-1rem">
                <button className="btn btn-outline-dark" onClick={regresar}>
                    Regresar
                </button>
                <button className="btn btn-primary" onClick={FormSubmit}>
                    Guardar
                </button>
            </div>
        </LoadMask>
    );
};
